/**
 * Shared utility for document expiration and freshness logic
 * Centralizes which document types can have expiration dates or freshness tracking
 */

// Document types that can have expiration dates (legal expiration)
const EXPIRABLE_DOC_TYPES = [
  'contract',
  'insurance', 
  'identity',
  'kbis',
  'attestation',
  'gray_card', // Carte grise can expire (contrôle technique)
  'prescription', // Ordonnances have validity
  'medical_certificate', // Certificats médicaux have validity
];

// Document types that track freshness (administrative validity, not legal expiration)
const FRESHNESS_TRACKED_DOC_TYPES = [
  'invoice', // Utility bills as domicile proof
  'receipt', // Rent receipts as domicile proof
];

/**
 * Check if a document type can have an expiration date (legal expiration)
 */
export function isExpirableDocType(docType: string | null | undefined): boolean {
  if (!docType) return false;
  return EXPIRABLE_DOC_TYPES.includes(docType);
}

/**
 * Check if a document type tracks freshness (administrative validity)
 */
export function isFreshnessTrackedDocType(docType: string | null | undefined): boolean {
  if (!docType) return false;
  return FRESHNESS_TRACKED_DOC_TYPES.includes(docType);
}

/**
 * Get the list of expirable document types
 */
export function getExpirableDocTypes(): readonly string[] {
  return EXPIRABLE_DOC_TYPES;
}

/**
 * Get the list of freshness-tracked document types
 */
export function getFreshnessTrackedDocTypes(): readonly string[] {
  return FRESHNESS_TRACKED_DOC_TYPES;
}
